/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const CrashSeverityLevel = {
    PropertyDamageOnly: 'PropertyDamageOnly',
    MinorInjury: 'MinorInjury',
    Injury: 'Injury',
    SeriousInjury: 'SeriousInjury',
    Fatal: 'Fatal'
};
export function CrashSeverityLevelFromJSON(json) {
    return CrashSeverityLevelFromJSONTyped(json, false);
}
export function CrashSeverityLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CrashSeverityLevelToJSON(value) {
    return value;
}
